import { render, staticRenderFns } from "./LabelV2.vue?vue&type=template&id=37d2a0fd&scoped=true"
import script from "./LabelV2.vue?vue&type=script&lang=js"
export * from "./LabelV2.vue?vue&type=script&lang=js"
import style0 from "./LabelV2.vue?vue&type=style&index=0&id=37d2a0fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2a0fd",
  null
  
)

export default component.exports